import React from "react";
import { Link } from "react-router-dom";
import { setUserClickData } from "../utility/setUserClickData";
import FooterSection from "./HomePageNew/components/footer/footer";

const FatakpayGrievance = () => {
  return (
    <div className="bg-black min-h-screen flex flex-col justify-between">
      <div className="container w-full h-full max-w-7xl mx-auto text-white px-3 sm:px-0 py-10">
        {/* Logo + Home */}
        <Link
          to={"/"}
          onClick={() => {
            setUserClickData({
              event_name: "link-to-home-page",
            });
          }}
        >
          <img
            className="pt-2"
            src="/assets/img/newLogo.png"
            alt="Digitmoney"
            width={160}
          />
        </Link>

        {/* Title Section */}
        <div className="pt-6">
          <h1 className="text-2xl md:text-3xl font-semibold text-green-400">
            FDPL Finance Private Limited
          </h1>
          <h2 className="mt-2 text-sm md:text-md font-semibold text-blue-300">
            Grievance Redressal Mechanism
          </h2>
        </div>

        {/* Content */}
        <div className="mt-10 mb-16 max-w-2xl">
          {/* GRO Details */}
          <div className="bg-gray-900/30 p-6 rounded-xl shadow-lg border-[1px] text-sm sm:text-lg border-gray-900">
            <h3 className="text-xl font-semibold text-white mb-3">
              Grievance Redressal Officer (GRO)
            </h3>
            <p className="text-gray-300 leading-relaxed">
              <span className="font-medium text-white">Name: </span>Ms. Vaishnavi Batulkar
              <br />
              <span className="font-medium text-white">Email: </span>
              <a
                href="mailto:escalation@fdplfinance.com"
                target="_blank"
                rel="noreferrer"
                className="text-green-400 font-medium text-sm sm:text-md hover:text-green-300 transition-colors"
              >
                escalation@fdplfinance.com
              </a>
              <br />
              <span className="font-medium text-white">Contact: </span>+91-9076058709 / 07969699880
              <br />
              <span className="font-medium text-white">Web Link: </span>
              <a
                href="https://www.fdplfinance.com/"
                target="_blank"
                rel="noreferrer"
                className="text-green-400 font-medium text-sm sm:text-md hover:text-green-300 transition-colors"
              >
                https://www.fdplfinance.com/
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <FooterSection />
    </div>
  );
};

export default FatakpayGrievance;